import * as angular from "angular";
import {IController} from "angular";
import {AgentModel} from "../../angular/models/agent.model";

export class AgentLinkTooltipCtrl implements IController {

  agent: AgentModel;
  agentReference: any;

  public agentMobilePhone: string = "";
  public agentVehicleType: string = "";

  $onInit() {
    this.agentMobilePhone = this.agent?.user?.mobilePhone || this.agentReference?.mobilePhone;
    this.agentVehicleType = this.agent?.vehicle?.type || this.agentReference?.vehicleType;
  }

  $onChanges(changes) {
    if ((changes.agent && !changes.agent.isFirstChange()) ||
      (changes.agentReference && !changes.agentReference.isFirstChange())) {
      this.$onInit();
    }
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentLinkTooltip', {
    bindings: {
      agent: '<?',
      agentReference: '<?'
    },
    template: require('./agent-link-tooltip.html').default,
    controller: AgentLinkTooltipCtrl
  });
